import { type FC, useState } from "react";
import { useApi } from "../api/APIContext";
import { useApiCall, ValidationError } from "../api/api";
import type { User } from "../api/dto";
import type { UserPermissions } from "../api/dto/UserPermissions";
import { Autocomplete } from "../components/form/Autocomplete";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const GrantCompanyAccessModal: FC<{
  user: User;
  inheritPermissions?: UserPermissions;
  onFinished?: (companyId?: string) => void;
}> = (props) => {
  const { companies } = useApi();
  const { grantCompanyAccessToUser } = useApiCall();
  const refresh = useRefresh();
  const [company, setCompany] = useState<string>("");
  const [errors, setErrors] = useState<string[]>([]);
  const companyMap = companies.filter((c) => !c.isArchived).map((c) => [c.id, c.name]);
  const selectedCompany = companies.find((c) => c.id === company);

  const save = async () => {
    if (!selectedCompany?.id) {
      return;
    }
    await grantCompanyAccessToUser(
      props.user.id,
      selectedCompany.id,
      props.inheritPermissions ?? {
        canExecuteAssessments: false,
        canExportAssessments: false,
        canAccessAllAssessments: false,
        canAccessAssessmentHistory: false,
        canManageCompanies: false,
        canManageCompaniesDestructive: false,
        canManageProjects: false,
        canManageProjectsDestructive: false,
        canManageAssessments: false,
        canManageAssessmentsDestructive: false,
        canAccessCertificates: false,
        canAccessDashboards: false,
        canAccessWeb: false,
        canAccessMobile: false,
        canImport: false,
        canManageUsers: false,
        canManageChecklists: false,
        accessibleQuestionSetTypes: [],
      },
    ).catch((e) => {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
      }
      throw e;
    });
    refresh();
  };
  return (
    <div className={""}>
      <div className={"min-h-71 flex-col space-y-3"}>
        <Autocomplete
          label={"Bedrijf"}
          value={company}
          options={Object.fromEntries(companyMap)}
          onChange={(c) => {
            setCompany(c);
          }}
        />
      </div>
      <ModalFooter text={"Opslaan"} disabled={!selectedCompany?.id} onSubmit={save} />
    </div>
  );
};
